import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';
import { postbackParamsHidden } from '../../../../config';
import config from '../../../../config';

const parameters = (state) => state.postbackParameters.list;
const postback = (state) => state.postbacks.list.data[0];
const pathnameSelector = (state) => {
    if (state.routing?.location?.pathname) {
        return state.routing.location.pathname;
    }
    if (state.routing?.locationBeforeTransitions?.pathname) {
        return state.routing.locationBeforeTransitions.pathname;
    }
    if (typeof window !== 'undefined' && window.location?.pathname) {
        return window.location.pathname;
    }
    return '';
};

export const getHeaderNames = createSelector(
    () => {
        const creatingEditingTableName = UserStore.getTranslation().postbackPage.creatingEditing.table;

        return [
            ' ',
            creatingEditingTableName.variableName,
            creatingEditingTableName.valueVariable,
            creatingEditingTableName.macros
        ];
    }
);

export const getData = createSelector(
    parameters,
    postback,
    pathnameSelector,
    (parameters = [], postback = {}, pathname = '') => {
        const isCreate = pathname.indexOf('/postback/create') !== -1;
        let postbackParameters = [];
        let list = [];
        let selected = [];

        if (!isCreate) {
            postbackParameters = (postback.config && postback.config.parameters && [...postback.config.parameters]) || [];
        }

        if (parameters.length) {
            parameters.map((item) => {
                if(postbackParamsHidden.indexOf(item.name) <= -1) {
                    let param = {
                        checked: false,
                        data: {
                            ...item
                        }
                    };
                    let index = postbackParameters.length ? postbackParameters.findIndex((item) => item.value === param.data.macros)
                        : -1;

                    if (index !== -1) {
                        param.checked = true;
                        param.data.name = postbackParameters[index].name;

                        selected.push({
                            name: postbackParameters[index].name,
                            value: param.data.macros
                        });
                        postbackParameters.splice(index, 1);
                    } else {
                        if (isCreate
                            && -1 !== config.postbackSettingsCreateEnable.indexOf(item.name)
                        ) {
                            param.checked = true;
                            param.data.name = item.name;

                            selected.push({
                                name: item.name,
                                value: param.data.macros
                            });
                        }
                    }

                    list.push(param);
                }
            });
        }

        return {
            list,
            selected: selected.concat(postbackParameters),
            extra: [...postbackParameters]
        };
    }
);
